var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Provisioning information: "),_c('br'),(null == _vm.provisioning_json)?_c('p',{staticClass:"font-italic"},[_vm._v("Not provided.")]):_c('vue-json-pretty',{attrs:{"data":_vm.provisioning_json}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }